module.exports = __webpack_public_path__ + "img/ccl_gallery13.1a63b9d3.jpg";